<template>
    <PopupRouterView :showLeftIcon="true" label="Part Purchase Quality Control Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="partpurchasequalitycontrol"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="partPurchaseQualityControlInput">


        <b-card header="Part Purchase Quality Control" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-datepicker  id="fieldset-part-purchase-quality-control-date" label-cols-lg="12"  label="Quality Control Date" size="sm" :model.sync="model.partPurchaseQualityControlDate" :isRequired="true" :state="validateState('partPurchaseQualityControlDate')" :errorMessage="getErrorMessage(errorMessage.partPurchaseQualityControlDate, 'partPurchaseQualityControlDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" />
						<app-input-textarea id="fieldset-description" label-cols-lg="12"  label="Description" label-for="input-description" size="sm" :model.sync="model.description"  @change="updateData" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">

		<app-table-input 
			title = "PartPurchaseQualityControlDetail"
			:bordered="true" :items="partPurchaseQualityControlDetails" 
			:fields="fieldsPartPurchaseQualityControlDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPartPurchaseQualityControlDetail" 
			:sort-desc.sync="sortDescPartPurchaseQualityControlDetail" small responsive	
			@editButtonMethod="editRowDataPartPurchaseQualityControlDetail"	
			@deleteButtonMethod="deleteRowDataPartPurchaseQualityControlDetail"	
			@showPopupAddMethod="addDataPartPurchaseQualityControlDetail()"	
			@showPopupUploadMethod="showPopupUploadPartPurchaseQualityControlDetail()"
			@downloadMethod="downloadPartPurchaseQualityControlDetail()"
			@addFromClipboardMethod="addFromClipboardPartPurchaseQualityControlDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPartPurchaseQualityControlDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadPartPurchaseQualityControlDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPartPurchaseQualityControlDetailFilter = !isShowPartPurchaseQualityControlDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPartPurchaseQualityControlDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="ControlCard">
					<v-select id="input-part-purchase-quality-control-detail-control-card-table" append-to-body label="controlCardNumber" :options="controlCards" :value="filterPartPurchaseQualityControlDetail.controlCardId" :reduce="item => item.id" v-model="filterPartPurchaseQualityControlDetail.controlCardId" @search="getControlCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Thickness">
					<b-form-input id="input-part-purchase-quality-control-detail-thickness-table" v-model="filterPartPurchaseQualityControlDetail.thickness" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Width">
					<b-form-input id="input-part-purchase-quality-control-detail-width-table" v-model="filterPartPurchaseQualityControlDetail.width" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Length">
					<b-form-input id="input-part-purchase-quality-control-detail-length-table" v-model="filterPartPurchaseQualityControlDetail.length" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-part-purchase-quality-control-detail-qty-table" v-model="filterPartPurchaseQualityControlDetail.qty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Karat">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-karat-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.karat"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Retak">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-retak-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.retak"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Goresan">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-goresan-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.goresan"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Gelombang">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-gelombang-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.gelombang"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Burry">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-burry-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.burry"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Benjolan">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-benjolan-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.benjolan"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Other Problem">
					<b-form-checkbox id="input-part-purchase-quality-control-detail-other-problem-table" class="float-right" v-model="filterPartPurchaseQualityControlDetail.otherProblem"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Ng Information">
					<b-form-input id="input-part-purchase-quality-control-detail-ng-information-table" v-model="filterPartPurchaseQualityControlDetail.ngInformation" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Control Card Status">
					<v-select id="input-part-purchase-quality-control-detail-control-card-status-table" append-to-body label="name" :options="controlCardStatuss" :value="filterPartPurchaseQualityControlDetail.controlCardStatusId" :reduce="item => item.id" v-model="filterPartPurchaseQualityControlDetail.controlCardStatusId" @search="getControlCardStatuss" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( partPurchaseQualityControlDetailPageSize * (currentPartPurchaseQualityControlDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-part-purchase-quality-control-detail-control-card-' + row.index" label-cols-lg="12" label="ControlCard" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveInputPartPurchaseQualityControlDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"    :nolabel="true" />
			</template>
			<template v-slot:cell(thickness)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-detail-thickness-' + row.index" label-cols-lg="12" label="Thickness" size="sm" :model.sync="row.item.thickness" :state="validateState('thickness')" :errorMessage="getErrorMessage(errorMessage.thickness, 'thickness')"   @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(width)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-detail-width-' + row.index" label-cols-lg="12" label="Width" size="sm" :model.sync="row.item.width" :state="validateState('width')" :errorMessage="getErrorMessage(errorMessage.width, 'width')"   @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(length)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-detail-length-' + row.index" label-cols-lg="12" label="Length" size="sm" :model.sync="row.item.length" :state="validateState('length')" :errorMessage="getErrorMessage(errorMessage.length, 'length')"   @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-detail-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(karat)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-karat-row-' + row.index" label-cols-lg="12" label="Karat" :model.sync="row.item.karat" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(retak)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-retak-row-' + row.index" label-cols-lg="12" label="Retak" :model.sync="row.item.retak" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(goresan)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-goresan-row-' + row.index" label-cols-lg="12" label="Goresan" :model.sync="row.item.goresan" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(gelombang)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-gelombang-row-' + row.index" label-cols-lg="12" label="Gelombang" :model.sync="row.item.gelombang" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(burry)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-burry-row-' + row.index" label-cols-lg="12" label="Burry" :model.sync="row.item.burry" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(benjolan)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-benjolan-row-' + row.index" label-cols-lg="12" label="Benjolan" :model.sync="row.item.benjolan" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(otherProblem)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-detail-other-problem-row-' + row.index" label-cols-lg="12" label="Other Problem" :model.sync="row.item.otherProblem" @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(ngInformation)="row">
				<app-input-textarea :id="'input-part-purchase-quality-control-detail-ng-information-' + row.index" label-cols-lg="12" label="Ng Information" size="sm" :model.sync="row.item.ngInformation"  @change="saveInputPartPurchaseQualityControlDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCardStatus)="row">
				<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" :id="'input-part-purchase-quality-control-detail-control-card-status-' + row.index" label-cols-lg="12" label="Control Card Status" size="sm" :model.sync="row.item.controlCardStatusId"  @change="saveInputPartPurchaseQualityControlDetail(row.item)" :selected="row.item.controlCardStatus != null ? row.item.controlCardStatus.name : ''"  @input="getControlCardStatuss" :loading="isControlCardStatusComboLoading"    :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<PartPurchaseQualityControlDetailInput 
					:model="modelPartPurchaseQualityControlDetail"
					:openPopup="isShowPopupPartPurchaseQualityControlDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPartPurchaseQualityControlDetail"/>
			</template>
			<template v-slot:upload-detail>
					<PartPurchaseQualityControlDetailUpload
					:openPopup="isShowPopupUploadPartPurchaseQualityControlDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPartPurchaseQualityControlDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPartPurchaseQualityControlDetailPage"
				:total-rows="totalPartPurchaseQualityControlDetailRow"
				:per-page="partPurchaseQualityControlDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
import PartPurchaseQualityControlList from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlList';
import PartPurchaseQualityControlFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlFilter';

import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PartPurchaseQualityControlDetail from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlDetail';
import PartPurchaseQualityControlDetailFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartPurchaseQualityControlDetailInput from '@/views/PartPurchaseQualityControl/PartPurchaseQualityControlDetailInput';
import PartPurchaseQualityControlDetailUpload from '@/views/PartPurchaseQualityControl/PartPurchaseQualityControlDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputCheckbox,
		PartPurchaseQualityControlDetailInput,PartPurchaseQualityControlDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partPurchaseQualityControlDate: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partPurchaseQualityControlDate: { required : "Quality Control Date is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPartPurchaseQualityControlDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "ControlCard", key: 'controlCard', sortable: false}}, 
				{"thickness": { "class" : "th-thickness", "label" : "Thickness", key: 'thickness', sortable: false}}, 
				{"width": { "class" : "th-width last-child", "label" : "Width", key: 'width', sortable: false}}, 
				{"length": { "class" : "th-length d-stack-none", "label" : "Length", key: 'length', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"karat": { "class" : "th-karat d-stack-none", "label" : "Karat", key: 'karat', sortable: false}}, 
				{"retak": { "class" : "th-retak d-stack-none", "label" : "Retak", key: 'retak', sortable: false}}, 
				{"goresan": { "class" : "th-goresan d-stack-none", "label" : "Goresan", key: 'goresan', sortable: false}}, 
				{"gelombang": { "class" : "th-gelombang d-stack-none", "label" : "Gelombang", key: 'gelombang', sortable: false}}, 
				{"burry": { "class" : "th-burry d-stack-none", "label" : "Burry", key: 'burry', sortable: false}}, 
				{"benjolan": { "class" : "th-benjolan d-stack-none", "label" : "Benjolan", key: 'benjolan', sortable: false}}, 
				{"otherProblem": { "class" : "th-other-problem d-stack-none", "label" : "Other Problem", key: 'otherProblem', sortable: false}}, 
				{"ngInformation": { "class" : "th-ng-information d-stack-none", "label" : "Ng Information", key: 'ngInformation', sortable: false}}, 
				{"controlCardStatus": { "class" : "th-control-card-status d-stack-none", "label" : "Control Card Status", key: 'controlCardStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPartPurchaseQualityControlDetail : {},
			isShowPopupPartPurchaseQualityControlDetail : false,
			isShowPopupUploadPartPurchaseQualityControlDetail : false,
			filterPartPurchaseQualityControl : null,
			currentPartPurchaseQualityControlPage : 1,
			partPurchaseQualityControlPageSize: 10,
			sortByPartPurchaseQualityControl: '',
			sortDescPartPurchaseQualityControl: '',
			filterPartPurchaseQualityControlDetail : null,
			currentPartPurchaseQualityControlDetailPage : 1,
			partPurchaseQualityControlDetailPageSize: 10,
			sortByPartPurchaseQualityControlDetail: '',
			sortDescPartPurchaseQualityControlDetail: '',
			sortingByPartPurchaseQualityControlDetail: [],
			partPurchaseQualityControlDetails : [],
			partPurchaseQualityControlDetailId : '',
			totalPartPurchaseQualityControlDetailRow : 0,
			isShowPartPurchaseQualityControlDetailFilter: false,
			isDownloadPartPurchaseQualityControlDetail: false,
			controlCards: [],
			controlCardStatuss: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isPartPurchaseQualityControlComboLoading: false,
			isControlCardStatusComboLoading: false,
		}
	},
	methods : {
		getPartPurchaseQualityControl : async function(id) {
			this.isBusy = true;
			PartPurchaseQualityControl.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartPurchaseQualityControl = true;
			this.filterPartPurchaseQualityControl.id = this.modelId;
			PartPurchaseQualityControl.downloadDataDetail(this, this.filterPartPurchaseQualityControl).then(result => {
				this.isDownloadPartPurchaseQualityControl = false;
			}).catch(error => { this.isDownloadPartPurchaseQualityControl = false; })
		},
		getPartPurchaseQualityControlDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartPurchaseQualityControlDetail);
			if (this.modelId == null) return;
			filter.partPurchaseQualityControlId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPartPurchaseQualityControlDetail != null) {
				this.sortingByPartPurchaseQualityControlDetail[this.sortByPartPurchaseQualityControlDetail] = this.sortDescPartPurchaseQualityControlDetail;
			}
			let currentPage = (this.currentPartPurchaseQualityControlDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartPurchaseQualityControlDetailRow + 1;
				let page = Math.ceil(totalData/this.partPurchaseQualityControlDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partPurchaseQualityControlDetailPageSize = 0;
			// disable paging end
			PartPurchaseQualityControlDetail.getList(this, filter, this.sortingByPartPurchaseQualityControlDetail, currentPage , this.partPurchaseQualityControlDetailPageSize).then(result => {
				this.currentPartPurchaseQualityControlDetailPage = currentPage + 1;
				this.partPurchaseQualityControlDetails = result.data;
				this.totalPartPurchaseQualityControlDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getPartPurchaseQualityControls : async function(input) {
			let filter = new PartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.PartPurchaseQualityControlDate = input;
			}
			this.isPartPurchaseQualityControlComboLoading = true;
			PartPurchaseQualityControl.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControls = result.data
				}
				this.isPartPurchaseQualityControlComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getPartPurchaseQualityControls : async function(input) {
			let filter = new PartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.partPurchaseQualityControlDate = input;
			}
			this.isPartPurchaseQualityControlComboLoading = true;
			PartPurchaseQualityControl.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControls = result.data
				}
				this.isPartPurchaseQualityControlComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isControlCardStatusComboLoading = true;
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
				this.isControlCardStatusComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partPurchaseQualityControlInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControl.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partpurchasequalitycontrolindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PartPurchaseQualityControl.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partpurchasequalitycontrolindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControl.updateData(this, model, id)
					.catch((error) => {
						this.getPartPurchaseQualityControl(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartPurchaseQualityControls();
		},
		addRowDataPartPurchaseQualityControlDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partPurchaseQualityControlId =  this.modelId;
					PartPurchaseQualityControlDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPartPurchaseQualityControlDetails(true);
						this.isShowPopupPartPurchaseQualityControlDetail = false;
					})
				} else {
					model.partPurchaseQualityControlId =  this.modelId;
					PartPurchaseQualityControlDetail.createDataDetail(this, model)
					.then(result => {
						this.getPartPurchaseQualityControlDetails(true);
						this.isShowPopupPartPurchaseQualityControlDetail = false;
					})
				}
			}
		},
		async editRowDataPartPurchaseQualityControlDetail(id) {
			this.partPurchaseQualityControlDetailId = id;
			this.isShowPopupPartPurchaseQualityControlDetail = true; 
		},
		async deleteRowDataPartPurchaseQualityControlDetail(id) {
			PartPurchaseQualityControlDetail.deleteData(this, id).then(result => { this.getPartPurchaseQualityControlDetails(); });
		},
		async resetDataPartPurchaseQualityControlDetail() {
			this.partPurchaseQualityControlDetailId = "";
			this.isShowPopupPartPurchaseQualityControlDetail = true;
		},
		async addDataPartPurchaseQualityControlDetail() {
			PartPurchaseQualityControlDetail.createData(this, { partPurchaseQualityControlId: this.modelId })
			.then(result => {
				this.getPartPurchaseQualityControlDetails(true);
			})
		},
		async addFromClipboardPartPurchaseQualityControlDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, partPurchaseQualityControlId: this.modelId });
				});
				PartPurchaseQualityControlDetail.addFromClipboard(this, controlCards).then(result => { this.getPartPurchaseQualityControlDetails() });
			});
		},
		async replaceFromClipboardPartPurchaseQualityControlDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, partPurchaseQualityControlId: this.modelId });
				});
				PartPurchaseQualityControlDetail.replaceFromClipboard(this, controlCards).then(result => { this.getPartPurchaseQualityControlDetails() });
			});   
		},
		showPopupUploadPartPurchaseQualityControlDetail() {
			if(this.partPurchaseQualityControlDetails != null && this.partPurchaseQualityControlDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PartPurchaseQualityControlDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPartPurchaseQualityControlDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPartPurchaseQualityControlDetail = true;
			}
		},
		uploadDataPartPurchaseQualityControlDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartPurchaseQualityControlDetail = false; 
		},
		downloadPartPurchaseQualityControlDetail(modalEvent) {
			this.isDownloadPartPurchaseQualityControlDetail = true;
			this.filterPartPurchaseQualityControlDetail.partPurchaseQualityControlId = this.modelId;
			PartPurchaseQualityControlDetail.downloadDataDetail(this, this.filterPartPurchaseQualityControlDetail).then(result => {
				this.isDownloadPartPurchaseQualityControlDetail = false;
			}).catch(error => { this.isDownloadPartPurchaseQualityControlDetail = false; })
		},
		saveInputPartPurchaseQualityControlDetail(item) {
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.partPurchaseQualityControls != null && this.partPurchaseQualityControls != undefined  && this.partPurchaseQualityControls.length > 0) {
				item.partPurchaseQualityControl = this.partPurchaseQualityControls.find(q => q.id == item.partPurchaseQualityControlId);
			}
			if (this.controlCardStatuss != null && this.controlCardStatuss != undefined  && this.controlCardStatuss.length > 0) {
				item.controlCardStatus = this.controlCardStatuss.find(q => q.id == item.controlCardStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControlDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPartPurchaseQualityControlDetail = false; 
			this.isShowPopupPartPurchaseQualityControlDetail = false; 
			if (modalType == 'PartPurchaseQualityControlDetail') {
				this.getPartPurchaseQualityControlDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPartPurchaseQualityControlDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPartPurchaseQualityControl = new PartPurchaseQualityControlFilter();
		this.filterPartPurchaseQualityControlDetail = new PartPurchaseQualityControlDetailFilter();
		//this.getControlCards();
		//this.getPartPurchaseQualityControls();
		//this.getControlCardStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartPurchaseQualityControl(id);
			} else {
				this.modelId = id;
				this.getPartPurchaseQualityControl(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByPartPurchaseQualityControlDetail : {
			handler: function() {
				this.getPartPurchaseQualityControlDetails();
			}
		},
		sortDescPartPurchaseQualityControlDetail: {
			handler: function() {
				this.getPartPurchaseQualityControlDetails();
			}
		},
		currentPartPurchaseQualityControlDetailPage: {
			handler: function() {
				this.getPartPurchaseQualityControlDetails();
			}
		},
		partPurchaseQualityControlDetailPageSize : {
			handler: function() {
				this.getPartPurchaseQualityControlDetails();
			}
		},
		filterPartPurchaseQualityControlDetail: {
			handler: function() {
				this.getPartPurchaseQualityControlDetails();
			},
			deep: true,
		},
	},
}
</script>
